import { render, staticRenderFns } from "./ModalHistoricoLotacaoList.vue?vue&type=template&id=d5e75cba"
import script from "./ModalHistoricoLotacaoList.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoLotacaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports